module.exports = __webpack_public_path__ + "svgs/icon_arrow.162d6374.svg";